<template>
  <div class="HeadView">
    <div class="head-wrap">
      <!-- <img
        src="@/assets/logo.png"
        alt=""
        class="logo"
        @click="toLogoPage"
      /> -->
      <div class="logo">和创药业</div>
      <div>
        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
          <el-menu-item index="/">走进和创</el-menu-item>
          <el-menu-item index="/onlineRetailers">设备仪器</el-menu-item>
          <el-menu-item index="/technologyView">产品展示</el-menu-item>
          <el-menu-item index="/logisticsView">和创荣誉</el-menu-item>
          <el-menu-item index="/memoirView">联系我们</el-menu-item>
          <el-menu-item index="/ECommerceAlliance">药物警戒</el-menu-item>
        </el-menu>
      </div>

      <!-- <i class="el-icon-switch-button quit" @click="quit"> 退出</i> -->

    </div>
    <div class="foot-wrap" :class="{ 'show': showFooter }">
      <div class="foot-word">资质证照</div>
      <div style="font-size: 20px;">ICP备案证书号：滇ICP备2024040638号&nbsp;&nbsp;&nbsp;</div>
      <div style="font-size: 20px;">互联网药品信息服务资格证编号：<a href="https://beian.miit.gov.cn/">（滇）-非经营性-2024-0034</a></div>
      <div style="font-size: 20px;">©2024 楚雄和创药业有限责任公司版权所有本网站未发布毒性药品、麻醉药品、精神药品、放射性药品、戒毒药品和医疗机构制剂的产品信息</div>
      <!-- 
      <div style="font-size: 20px;">ICP备案证书号：<span
          style="color: red;font-size: 20px;">滇ICP备2021000143号</span>互联网药品信息服务资格证编号：<span
          style="color: red;">(滇)-非经营性-2020-0095</span>增值电信业务经营许可编号：</div>
      <div style="font-size: 20px;">©2020 云南云医康医药有限责任公司版权所有本网站未发布毒性药品、麻醉药品、精神药品、放射性药品、戒毒药品和医疗机构制剂的产品信息</div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HeadView",
  data() {
    return {
      activeIndex: "/",
      showFooter: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.checkIfFooterShouldShow(); // 初始化检查一次
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$nextTick(() => {
        this.checkIfFooterShouldShow(); // 初始化检查一次
      })
    },
    toLogoPage() {
      this.$router.push('/logoPage')
    },
    quit() {
      sessionStorage.clear('token')
    },
    handleScroll() {
      this.checkIfFooterShouldShow();
    },
    checkIfFooterShouldShow() {
      let contentHeight = document.documentElement.scrollHeight;
      let yOffset = window.pageYOffset;
      let windowHeight = window.innerHeight;

      // 当滚动条接近页面底部时显示底部内容
      if (yOffset + windowHeight >= contentHeight - 100) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.HeadView {
  // min-width: 1820px;
  display: flex;
  justify-content: center;
  position: relative;
}

.head-wrap {
  width: 19rem;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}



.logo {
  font-size: 30px;
  color: #fff;
  cursor: pointer;
  width: 2.225rem;
  height: .75rem;
  z-index: 999;
}

.el-menu-demo {
  // width: 8.75rem;
  height: .75rem;
  background: rgba($color: #ffffff, $alpha: 0);
  border: none;
}

::v-deep .el-menu.el-menu--horizontal {
  border: none;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none !important;
  color: #ffffff !important;
  font-size: .2rem !important;
  font-weight: 500 !important;
  background: none !important;
}

::v-deep .el-menu-item {
  color: #909399 !important;
  font-size: .2rem !important;
  font-weight: 300 !important;
  border-bottom: none !important;
  background: none !important;
}

::v-deep .el-menu-item:hover {
  color: #ffffff !important;
  font-size: .2rem !important;
  font-weight: 500 !important;
  background: none !important;
}

// ::v-deep .el-menu-item:active {
//   color: #ffffff !important;
//   font-size: 20px !important;
//   font-weight: 500 !important;
//   background: none !important;
// }
::v-deep .el-submenu__title:focus .el-submenu__title:hover {
  background: none !important;
}

::v-deep .el-menu-demo li {
  background: none;
}

.quit {
  color: #ffffff;
  font-size: .2rem;
  position: absolute;
  top: 45%;
  right: 5%;
  cursor: pointer;
  opacity: 0.8;
}

.foot-wrap {
  display: none;
  /* 初始隐藏 */
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  text-align: center;
  padding: 10px 0;
  // border-top: 10px solid;
  z-index: 1000;
  margin-top: 10px;
}

.show {
  display: block;
  /* 满足条件时显示 */
}

.foot-word {
  font-size: 30px;
  font-weight: 700;
}
</style>
